import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { AntDataResponse } from '@antony/ng-ui';
import { AntCollectionSortLoadingParams, ResourceCollectionApiService } from '@api/models';
import { ConstructionProjectDto, ContactPersonConstructionProjectsApiService } from '@api/api.service';
import { LoadingParamsUtils } from '@api/utils';
import { concatMap, map, switchMap, toArray } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContactPersonConstructionProjectService implements ResourceCollectionApiService<ConstructionProjectDto> {
  constructor(private api: ContactPersonConstructionProjectsApiService) {}

  getData(params: AntCollectionSortLoadingParams<ConstructionProjectDto>): Observable<AntDataResponse<ConstructionProjectDto>> {
    return this.api
      .getPagedConstructionProjects(
        LoadingParamsUtils.getIdFrom(params),
        LoadingParamsUtils.getSkipFrom(params),
        LoadingParamsUtils.getTakeFrom(params),
        LoadingParamsUtils.getFilterNamesFrom(params),
        LoadingParamsUtils.getFilterValueFrom(params),
        LoadingParamsUtils.getSortNamesFrom(params),
        LoadingParamsUtils.getApiSortDirection(params)
      )
      .pipe(
        map((res) => ({
          data: res.data || [],
          maxCount: res.maxCount || 0,
        }))
      );
  }

  add(contactPersonId: number, constructionProjectId: number): Observable<boolean> {
    return this.api.createConstructionProjects(contactPersonId, constructionProjectId).pipe(map((res) => res.success));
  }

  addBulk(contactPersonId: number, constructionProjectIds: number[]): Observable<boolean[]> {
    return from(constructionProjectIds).pipe(
      concatMap((constructionProjectId) => this.add(contactPersonId, constructionProjectId)),
      toArray()
    );
  }

  remove(contactPersonId: number, constructionProjectId: number): Observable<boolean> {
    return this.api.deleteConstructionProject(contactPersonId, constructionProjectId).pipe(map((res) => res.success));
  }

  removeBulk(contactPersonId: number, constructionProjectIds: number[]): Observable<boolean[]> {
    return this.api.deleteBulkConstructionProjects(contactPersonId, constructionProjectIds).pipe(
      map((res) => res.data || []),
      switchMap((responses) => from(responses)),
      map((res) => res.success),
      toArray()
    );
  }
}
